import type { FaireProductEntity } from "../../entity_types/product";

export const p_t3xyjycqp3: FaireProductEntity = {
  token: "p_t3xyjycqp3",
  type: "product",
  name: "Ghouls Just Wanna Have Fun Halloween Sweatshirt - Kids",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/f2d711f3b0f8b7f672385dcfd3e5ba27f9935096ff6b0115862ed18ea49b7f94.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dc070a560bf5d0565e2c5151340ce77ed291663df5902300205ddf81740f0b00.jpeg",
    "https://cdn.faire.com/fastly/70a83c7c4ac0290bfbb8cea493810f497087e10e1bd17de87011622f47bd4119.jpeg",
    "https://cdn.faire.com/fastly/459850f3fd0d518bc2ca12cd4970f62c70cc5bd61edd4657cc4bd540d23cb3ec.jpeg",
    "https://cdn.faire.com/fastly/3a1eaef428d0e8dddd4d2fcff2660e2cd4303a1ff73b8b5c72960236fcdfe180.jpeg",
    "https://cdn.faire.com/fastly/eb31427f362f52f5c6a816164b702816d07eab672b223676075b808521f43464.jpeg",
  ],
  priceDollars: 21,
  description:
    "Cute, comfy, and made for little ghouls who love to have fun, this playful sweatshirt brings all the spooky season vibes.\n\nFeatures:\n * Crewneck Color: Ballet Pink \n * Graphic Color: Black and white \n * Material: 60% Cotton/40% Polyester Fleece \n * Features: Tagless inside neck label for an itch-free wear, cozy brushed fleece. Designed with little ones in mind, sizes 12-18m and 18-24m include back buttons for easy changes. \n * Fit: Toddler Unisex; True to Size \n * Care: Machine washable, tumble dry low, wash with like colors \n\nEach sweatshirt is hand pressed with love in our hometown warehouse.",
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:34:31.582Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
